import { makeStyles } from "tss-react/mui"
import { blueGrey, indigo } from "../../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ palette, spacing, shadows }) => ({
  iconDropDown: {
    backgroundColor: palette.primary[900],
    color: palette.common.white,
    borderRadius: 50,
    padding: `${spacing(1)} ${spacing(2)}`,
    outline: "unset !important"
  },
  profileAvatar: {
    fontSize: "0.88rem !important",
    width: 30,
    height: 30,
    textTransform: "uppercase",
    backgroundColor: indigo[500]
  },
  dropDownEndIcon: {
    marginLeft: spacing(1),
    marginRight: 0
  },
  paper: {
    marginRight: spacing(2),
    marginTop: spacing(2),
    width: "195px",
    borderRadius: "4px",
    boxShadow: shadows[1],
    minWidth: "auto"
  },
  mainButton: {
    backgroundColor: palette.primary[500],
    "&:hover": {
      backgroundColor: palette.primary[600]
    },
    "&[aria-controls=profile-dropdown-menu]": {
      backgroundColor: palette.common.white,
      color: palette.primary.main
    },
    "&:focus": {
      outline: "none"
    }
  },
  mainButtonIcon: {
    fontSize: "0.6875rem"
  },
  menuList: {
    color: palette.primary[500],
    fontSize: "0.6875rem",
    padding: spacing(2, 0)
  },
  menuListItem: {
    color: blueGrey[500],
    paddingBottom: spacing(2),
    paddingTop: spacing(2)
  }
}))
